/** @format */
import { PriceModifier } from '@toucan/client/global/product';

/**
 *
 * @param priceModifiers An array of price modifiers
 * @param columns How many columns to split them into
 * @param maxItemsPerColumn The maximum number of price modifiers per column
 * @returns An array of arrays containing price modifiers
 */
export const splitPriceModifiersIntoColumns = (
    priceModifiers: PriceModifier[],
    columns: number = 1,
    maxItemsPerColumn: number = Infinity
) => {
    const priceModifiersClone = [...priceModifiers];
    const itemsLimit = columns * maxItemsPerColumn;
    const visiblePriceModifiers = priceModifiersClone.splice(0, itemsLimit);

    const result = [];
    for (let i = columns; i > 0; i--) {
        result.push(
            visiblePriceModifiers.splice(
                0,
                Math.ceil(visiblePriceModifiers.length / i)
            )
        );
    }

    return {
        priceModifierColumns: result,
        totalHiddenPriceModifiers: priceModifiersClone.length,
    };
};
